export interface PosterItem {
  id: number;
  img: string;
  title: string;
}

const posterImages = {
  poster1: require("@/assets/images/posters/1.jpg"),
  poster2: require("@/assets/images/posters/2.jpg"),
  poster3: require("@/assets/images/posters/3.jpg"),
  poster4: require("@/assets/images/posters/4.jpg"),
  poster5: require("@/assets/images/posters/5.jpg"),
  poster6: require("@/assets/images/posters/6.jpg"),
};

export const postersData: PosterItem[] = [
  {
    id: 1,
    img: posterImages.poster1,
    title: "Don't share your password with anyone"
  },
  {
    id: 2,
    img: posterImages.poster2,
    title: "Learn how to detect phishing emails"
  },
  {
    id: 3,
    img: posterImages.poster3,
    title: "Securing Digital Identity"
  },
  {
    id: 4,
    img: posterImages.poster4,
    title: "Do Not Talk To Strangers"
  },
  {
    id: 5,
    img: posterImages.poster5,
    title: "Passphrases and unforgettable passwords"
  },
  {
    id: 6,
    img: posterImages.poster6,
    title: "Secure Your Smartphone with biometrics"
  }
];

export default postersData;
